import { errorFactory } from '@sky-it-livedata-libraries/livedata-commons';

const errors = errorFactory({
  2000: 'Generic Calendar Error',
  2001: 'error in Calendar transformer()',
  3000: 'Generic Ranking Error',
  3001: 'error in Ranking transformer()',
  3002: 'Generic Ranking Subscription Error',
  3003: 'error in Ranking Subscription transformer()',
  4000: 'Generic Results Error',
  4001: 'error in Results transformer()',
  4002: 'Generic Results Subscription Error',
  4003: 'error in Results Subscription transformer()',
  5000: 'Generic Results Categories Error',
  5001: 'error in Results Categories transformer()',
  6000: 'Generic Live Score Error',
  6001: 'error in Live Score transformer()',
  6002: 'Generic Live Score Subscription Error',
  6003: 'error in Live Score Subscription transformer()',
});

export default errors;